// extracted by mini-css-extract-plugin
export default {"meta":"SubmitNewCustomisation-meta-kRu","additionalNewIconInfo":"SubmitNewCustomisation-additionalNewIconInfo-qR8","button":"SubmitNewCustomisation-button-Wc3"};